namespace AgerLMS.Coaching {
    export interface SeriesMarker {
        enabled?: boolean;
    }
}
